@if (showModal()) {
<app-modal (closeModal)="close()">
  <h1 modal-title>{{ buttonText }} Usuario</h1>

  <form
    [formGroup]="userForm"
    (submit)="submit()"
    class="flex flex-col gap-4"
    modal-content
  >
    <!-- <div class="flex flex-row gap-x-2"> -->
    <div class="flex flex-col gap-2">
      <label for="first-name">Nombre</label>
      <input
        type="text"
        id="first-name"
        formControlName="first_name"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="last-name">Primer Apellido</label>
      <input
        type="text"
        id="last-name"
        formControlName="last_name"
        class="basic-input"
      />
    </div>
    <!-- </div> -->

    <!-- <div class="flex flex-row gap-x-2"> -->
    <div class="flex flex-col gap-2">
      <label for="second-last-name">Segundo Apellido</label>
      <input
        type="text"
        id="second-last-name"
        formControlName="second_last_name"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="birth-date">Fecha de Nacimiento</label>
      <input
        type="date"
        id="birth-date"
        formControlName="birth_date"
        class="basic-input"
      />
    </div>
    <!-- </div> -->

    <!-- <div class="flex flex-row gap-x-2"> -->
    <div class="flex flex-col gap-2">
      <label for="phone">Teléfono</label>
      <input
        type="tel"
        id="phone"
        formControlName="phone"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="email">Correo Electrónico</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="basic-input"
      />
    </div>
    <!-- </div> -->

    <!-- <div class="flex flex-row gap-x-2"> -->
    <div class="flex flex-col gap-2">
      <label for="username">Nombre de Usuario</label>
      <input
        type="text"
        id="username"
        formControlName="username"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="password">Contraseña</label>
      <input
        type="password"
        id="password"
        formControlName="password"
        class="basic-input"
      />
    </div>
    <!-- </div> -->

    <div class="flex flex-col gap-2">
      <label for="role">Rol</label>
      <ng-select
        id="role"
        [items]="roles"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        [searchable]="false"
        [clearable]="false"
        [closeOnSelect]="true"
        formControlName="role"
      >
      </ng-select>
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row sm:justify-between sm:space-x-2"
    >
      <button type="button" class="secondary normal" (click)="cancel()">
        Cancelar
      </button>

      <button
        type="submit"
        [disabled]="userForm.invalid"
        class="primary normal"
      >
        {{ buttonText }}
      </button>
    </div>

    @if (confirmationMessage && userForm.pristine) {
    <span class="mt-2 text-green-700 text-sm">{{ confirmationMessage }}</span>
    } @if (errorMessage && userForm.pristine) {
    <span class="mt-2 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </form>
</app-modal>
}
